export default __webpack_public_path__ + "static/media/signup_banner_En.58b65fc5.jpg";